<template>
  <v-snackbar
    location="top right"
    v-model="state.show"
    :color="state.color"
    :timeout="state.timeout"
  >
    <div class="text-pre-line">
      {{ state.text }}
    </div>

    <template #actions>
      <v-btn
        variant="text"
        size="small"
        aria-label="Close notification"
        icon="mdi-close"
        @click="close"
      />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useSnackbar } from '@/composable/useSnackbar';

const { state, close } = useSnackbar();
</script>

<style lang="scss" scoped>
.text-pre-line {
  white-space: pre-line;
}
</style>
